import React from 'react';
import SelectWithIndeterminate from '../../../common/SelectWithIndeterminate';
import { USE_SERVICE_DURATION_FOR_TIMES } from '../constants';
import ToolTip from '../../../common/tooltip';
import withMinuteOptions, { minuteOptionShape } from '../../../common/hoc/withMinuteOptions';

const MinServiceLenSelect = ({ minuteOptionsNoZero }) => (
  <div className="layout__item">
    <div>
      <span className="c-label-new">Client Booking Interval:</span>
      <div className="u-visible-inline-block-for-medium-and-up">
        <ToolTip
          text="This defines what open times are shown to clients. For example, a 15
          minute interval would show 10:00am and then 10:15am."
        />
      </div>
    </div>
    <SelectWithIndeterminate
      name="minServiceLen"
      className="c-select c-select--small u-3/5 u-2/5-extralarge-and-up u-mv0"
      options={[
        ...minuteOptionsNoZero.map(time => ({
          value: time,
          label: `${time} mins`,
        })), {
          value: USE_SERVICE_DURATION_FOR_TIMES,
          label: 'By service length',
        }]}
      valueField="value"
      textField="label"
      empty
    />
  </div>
);

MinServiceLenSelect.propTypes = {
  minuteOptionsNoZero: minuteOptionShape.isRequired,
};

export default withMinuteOptions(MinServiceLenSelect);
